import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { AppRoutes } from "../utils";

export const Route = createFileRoute("/_auth")({
  notFoundComponent: () => {
    return <p>The Page you requested was not found</p>;
  },
  beforeLoad: ({
    context: {
      app: {
        state: { user },
      },
    },
  }) => {
    if (user) {
      throw redirect({ to: AppRoutes.DASHBOARD });
    }
  },
  component: () => {
    return (
      <div className="min-h-screen md:bg-main py-10 md:bg-primary">
        <main className="mx-auto lg:w-2/6 md:w-4/6 max-w-[650px] bg-white px-8 pt-6 pb-1 md:rounded-lg md:shadow-lg">
          <div className="mb-6 flex justify-center">
            <img
              src="/images/logo.jpeg"
              alt="Passportmonie-Logo"
              className="h-16"
            />
          </div>

          <Outlet />
        </main>
      </div>
    );
  },
});
